import SectionHeader from '../ui/SectionHeader';
import AnimatedCard from '../ui/AnimatedCard';
import MotionReveal from '../ui/MotionReveal';
import { experience, sectionCopy } from '../../data/portfolioData';

const typeBadge = {
  current: { label: 'CURRENT', className: 'border-ant-gold/30 bg-ant-gold/10 text-ant-gold' },
  internship: { label: 'INTERNSHIP', className: 'border-white/10 bg-white/[0.04] text-white/40' },
  freelance: { label: 'FREELANCE', className: 'border-white/10 bg-white/[0.04] text-white/40' },
};

const Experience = () => {
  const copy = sectionCopy.experience;

  return (
    <section id="experience" className="section-padding bg-ant-bg text-ant-fg border-t border-ant-line-soft">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          label={copy.label}
          titleLine1={copy.titleLine1}
          titleLine2={copy.titleLine2}
          subtitle={
            <>
              {copy.subtitle}{' '}
              <a
                href="https://www.linkedin.com/in/griffins-siele-4201871b0/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-ant-gold/80 hover:text-ant-gold transition-colors underline underline-offset-4"
              >
                LinkedIn
              </a>
              .
            </>
          }
        />

        <div className="grid md:grid-cols-2 gap-4 lg:gap-5">
          {experience.map((item, index) => {
            const badge = typeBadge[item.type];
            return (
              <MotionReveal
                key={item.id}
                delay={index * 80}
                className={item.type === 'current' ? 'md:col-span-2' : ''}
              >
                <AnimatedCard className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-7 flex flex-col hover:border-white/[0.14] h-full">
                  <div className="flex items-start justify-between gap-4 mb-5">
                    <div className="flex items-center gap-3 min-w-0">
                      <span className="font-mono text-[11px] tracking-[0.2em] text-white/25 shrink-0">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="h-px w-8 bg-white/[0.08] shrink-0" />
                      <div className="min-w-0">
                        <h3 className="text-base font-semibold text-white truncate">{item.role}</h3>
                        <p className="text-sm text-ant-gold/80 mt-0.5">{item.company}</p>
                      </div>
                    </div>
                    {badge && (
                      <span
                        className={`shrink-0 px-2.5 py-1 rounded-full border font-mono text-[10px] tracking-wider ${badge.className}`}
                      >
                        {badge.label}
                      </span>
                    )}
                  </div>

                  <div className="flex flex-wrap gap-3 text-[11px] font-mono text-white/30 mb-5">
                    <span>{item.period}</span>
                    <span className="text-white/15">·</span>
                    <span>{item.location}</span>
                  </div>

                  <ul className="space-y-2.5 mb-6 flex-1">
                    {item.highlights.map((highlight, i) => (
                      <li key={i} className="flex items-start gap-3 text-sm text-white/45 leading-relaxed">
                        <span className="font-mono text-ant-green mt-0.5 shrink-0">›</span>
                        {highlight}
                      </li>
                    ))}
                  </ul>

                  <div className="rounded-xl border border-white/[0.06] bg-ant-bg-2 p-4 font-mono text-[11px] space-y-1.5">
                    {item.technologies.map((tech) => (
                      <p key={tech} className="text-white/35">
                        <span className="text-ant-green">›</span> {tech}
                      </p>
                    ))}
                  </div>
                </AnimatedCard>
              </MotionReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Experience;